<script>
import LayoutGallery from '@/layouts/LayoutGallery.vue'
import Gallery from '@/components/Gallery.vue'
import Header from '@/components/Header.vue'

export default {
  page: {
    title: 'Best after image'
  },
  components: {
    LayoutGallery,
    Gallery,
    Header
  },
  data() {
    return {
      currentAssetId: null,
      images: [],
      selected: null,
      isLoadingImages: false,

      metadata: null,
      isLoadingMetadata: false
    }
  },
  created() {
    window.Labelbox.currentAsset().subscribe(asset => {
      if (!asset || !asset.data) {
        return
      }

      // ???
      if (this.currentAssetId === asset.id) {
        return
      }

      this.currentAssetId = asset.id
      this.$store.dispatch('assets/getAssetData', asset)

      this.loadImages(asset.id)
      this.loadMetadata(asset.id)
    })

    const preloadFunction = asset => {
      return new Promise(resolve => {
        this.$store.dispatch('assets/getAssetData', asset)
        resolve()
      })
    }

    window.Labelbox.enablePreloading({ preloadFunction })
  },

  methods: {
    async loadImages(id) {
      const byId = this.$store.getters['assets/byId']
      const promises = byId(id).promises

      try {
        this.isLoadingImages = true
        this.images = await promises.images
      } catch (e) {
        this.$toasted.error('Unable to load image data.')
      } finally {
        this.isLoadingImages = false
      }
    },
    async loadMetadata(id) {
      const byId = this.$store.getters['assets/byId']
      const promises = byId(id).promises

      try {
        this.isLoadingMetadata = true
        const response = await Promise.all([
          promises.event,
          promises.installation,
          promises.menu
        ])

        const event = response[0]
        const installation = response[1]
        const menu = response[2][0]

        this.metadata = {
          Kitchen: installation.location,
          'Device ID': event.deviceId,
          Time: event.ts,
          Stage: event.stage,
          Reason: event.reason,
          'Menu Name': menu.menuName,
          'Menu ID': menu.menuId,
          'Transaction ID': event.guid,
          'Event ID': event.id,
          'Transaction Type': event.type
        }
      } catch (e) {
        this.$toasted.error('Unable to load metadata.')
      } finally {
        this.isLoadingMetadata = false
      }
    },

    changeSelectedImage(id) {
      this.selected = id
    },
    updateAsset(payloadData) {
      const byId = this.$store.getters['assets/byId']
      const data = byId(this.currentAssetId).data

      const payload = JSON.stringify({
        ...payloadData,
        eventId: data.eventId
      })

      window.Labelbox.setLabelForAsset(payload)
        .then(() => {
          this.selected = null
          this.$store.commit('assets/DELETE_ASSET', this.currentAssetId)

          window.Labelbox.fetchNextAssetToLabel()
        })
        .catch(() => {
          this.$toasted.error('Labelbox: Unable to submit event.')
        })
    }
  }
}
</script>

<template>
  <LayoutGallery>
    <template v-slot:header>
      <Header
        :metadata="metadata"
        :selected="selected"
        @reject="updateAsset({ rejected: $event })"
        @submit="updateAsset({ selectedImage: selected })"
      />
    </template>

    <template v-slot:default>
      <Spinner v-if="isLoadingImages" class="spinner-md" />

      <Gallery
        v-else
        :images="images"
        :selected="selected"
        @select="changeSelectedImage($event)"
      />
    </template>
  </LayoutGallery>
</template>
